import { useTranslation } from 'react-i18next';
import { Notification } from './Notification';
import { NotificationLevel } from './Notification.enums';

export const FreightQuoteNotification = ({
    isDynamicDeliveryPriceEnabled,
    error,
}: {
    isDynamicDeliveryPriceEnabled: boolean;
    error?: boolean;
}) => {
    const { t } = useTranslation(['uiPrimitive']);
    if (!isDynamicDeliveryPriceEnabled) {
        return null;
    }
    return (
        <Notification
            level={error ? NotificationLevel.ERROR : NotificationLevel.INFO}
            message={error ? t('notification.freightQuoteUnavailable') : t('notification.freightEstimate')}
            disableScroll
        />
    );
};
